import type { TFunction } from "i18next";

export function GoogleRegisterSection({
  t,
  googleEnabled,
  googleRegister,
  loading = false,
}: {
  t: TFunction;
  googleEnabled: boolean;
  googleRegister: () => void;
  loading?: boolean;
}) {
  return (

          <div className="mb-6">
              <button
                type="button"
                onClick={() => googleRegister()}
                disabled={loading || !googleEnabled}
                className="inline-flex w-full items-center justify-center gap-3 rounded-xl border border-[var(--color-border)] bg-[var(--color-white)] px-5 py-3.5 text-sm font-semibold text-[var(--color-midnight_text)] shadow-sm transition-all duration-200 hover:border-[var(--color-tealGreen)]/40 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-60 disabled:pointer-events-none dark:border-[var(--color-dark_border)] dark:bg-[var(--color-slateGray)] dark:text-[var(--color-white)] dark:hover:border-[var(--color-primary)]/40"
              >
                {loading ? (
                  <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current/30 border-t-current" />
                ) : (
                  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden>
                    <path fill="#4285F4" d="M21.8 12.2c0-.8-.1-1.6-.2-2.3H12v4.4h5.5a4.7 4.7 0 0 1-2 3.1v2.6h3.2c1.9-1.8 3.1-4.5 3.1-7.8Z" />
                    <path fill="#34A853" d="M12 22c2.7 0 5-.9 6.7-2.5l-3.2-2.6c-.9.6-2.1 1-3.5 1-2.7 0-5-1.8-5.8-4.3H2.9v2.7A10 10 0 0 0 12 22Z" />
                    <path fill="#FBBC05" d="M6.2 13.6A6 6 0 0 1 5.9 12c0-.6.1-1.1.3-1.6V7.7H2.9A10 10 0 0 0 2 12c0 1.6.4 3.2 1 4.3l3.2-2.7Z" />
                    <path fill="#EA4335" d="M12 6.1c1.5 0 2.8.5 3.9 1.5l2.9-2.9A9.8 9.8 0 0 0 12 2 10 10 0 0 0 2.9 7.7l3.3 2.7c.8-2.5 3.1-4.3 5.8-4.3Z" />
                  </svg>
                )}
                {loading ? t("submitting") : t("googleRegister")}
              </button>
              {!googleEnabled && <p className="mt-2 text-xs text-[var(--color-warning)]">{t("googleSetupHint")}</p>}

              <div className="my-5 flex items-center gap-4">
                <div className="h-px flex-1 bg-[var(--color-border)] dark:bg-[var(--color-dark_border)]" />
                <span className="text-xs font-medium text-[var(--color-charcoalGray)] dark:text-[var(--color-muted)]">{t("orContinueWith")}</span>
                <div className="h-px flex-1 bg-[var(--color-border)] dark:bg-[var(--color-dark_border)]" />
              </div>
            </div>
  );
}
